import SideBarLayout from "../SideBarLayout/SideBarLayout";

const OrganLayout = ({ children }) => {
  return (
    <div className="container-fluid">
      <div id="layout-wrapper">
        {/* <HeaderLayout isOrgan/> */}
        <SideBarLayout isOrgan />

        <div className="main-content">
          <div className="page-content">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default OrganLayout;
